// extracted by css-extract-rspack-plugin
export default {"input":"u_wcJ"};